import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import loginService from "../../../services/login/loginService";
import HeaderAuth from "./HeaderAuth";
import HeaderUnauth from "./HeaderUnauth";
import HeaderUnTnc from "./HeaderUnTnc";
import "../../../assets/scss/components/header.scss";
import { MyAuthContext } from "../../../Context/AuthContext";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import { getTolocalStorage } from "../../Constants/commenFeatures";
import { accRedircet } from "../../../services/genralServise";
import { config } from "../../../config/domain";

const Header = (props) => {
  let myAuthContext = useContext(MyAuthContext);
  const [isNavbar, setIsNavbar] = useState(false);

  const showNavbar = async () => {
    await setIsNavbar(!isNavbar);
  };

  const logout = () => {
    let loginAs = getTolocalStorage("loginAs");
    if (loginAs === "vendor") {
      loginService.vendorLogout();
    } else {
      loginService.logout();
    }
    myAuthContext.isAuthFunction(false, false);
    accRedircet(config.root);
  };

  const gettingHeader = () => {
    if (myAuthContext && myAuthContext.isAuth && myAuthContext.tncAccepted) {
      return (
        <HeaderAuth
          logout={logout}
          isNavbar={isNavbar}
          showNavbar={showNavbar}
        />
      );
    } else if (
      myAuthContext &&
      myAuthContext.isAuth &&
      !myAuthContext.tncAccepted
    ) {
      return (
        <HeaderUnTnc
          isNavbar={isNavbar}
          showNavbar={showNavbar}
          logout={logout}
        />
      );
    } else {
      return <HeaderUnauth isNavbar={isNavbar} showNavbar={showNavbar} />;
    }
  };

  return (
    <div>
      <div className={isNavbar ? "header bg_black" : "header "}>
        <div className="container">
          <nav className="display-space-between mobileViewNav">
            <div className="head mobileViewHead">
              <Link to="/">
                <img src={NuvamaLogo} alt="nuvama-logo" />
              </Link>
              <div onClick={showNavbar}>
                {isNavbar ? (
                  <span>
                    <i className="edel-icon-close"></i>
                  </span>
                ) : (
                  <span className="">
                    <i className="edel-icon-bars"></i>
                  </span>
                )}
              </div>
            </div>
            <div className="mobileViewHide">{gettingHeader()}</div>
          </nav>
        </div>
      </div>
      {props.children}
    </div>
  );
};

export default Header;
